<div class="container-fluid">
    <div class="row justify-content-center h-100">
        <mat-progress-spinner class="m-auto" mode="indeterminate" color="primary"></mat-progress-spinner>
    </div>
</div>